import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getPageContentBySlug } from 'context/actions/pages';
import { SET_PAGE_COVER } from 'context/actions/system';
import PageHero from 'components/PageHero';

/**
 * Тогтмол стилтэй inner page header.
 * Бүх /about/*, /project/*, /transparency/*, /hr/* хуудаснуудад ашиглана.
 *
 * Props:
 *   slug     — pages model URL талбар (жш 'about/board'). Cover image татах,
 *              Header overlay горим автоматаар шилжүүлэх.
 *   eyebrow  — (заавал биш) ашиглагдахгүй ч хадгална
 *   title    — гарчиг
 *   subtitle — (заавал биш) ашиглагдахгүй ч хадгална
 *
 * Хэрэглээ:
 *   <PageHeader slug="about/board" title="ТУЗ" />
 *
 * Ажиллах горим:
 *   Cover image-тэй → <PageHero title=... image=... /> (Header-ийн ард нэвт)
 *   Cover image-гүй → Title + yellow underline (light bg, pt-28..pt-40)
 */
export default function PageHeader({ slug, title, subtitle }) {
    const dispatch = useDispatch();

    const [coverImage, setCoverImage] = useState(null);

    useEffect(() => {
        if (!slug) return;

        let cancelled = false;
        (async () => {
            try {
                const res = await getPageContentBySlug(slug);
                if (cancelled) return;
                if (res?.data?.coverImage) {
                    setCoverImage(res.data.coverImage);
                    // Header overlay горим идэвхжүүлэх
                    dispatch({ type: SET_PAGE_COVER, data: true });
                }
            } catch (e) {
                // Pages API хариу буцаахгүй бол cover-гүй plain header харагдана
            }
        })();

        return () => {
            cancelled = true;
            // Хуудас солихоор Header overlay горимыг буцаах
            dispatch({ type: SET_PAGE_COVER, data: false });
        };
    }, [slug, dispatch]);

    // Cover image-тэй — нүүр шиг PageHero
    if (coverImage) {
        return (
            <PageHero
                title={title}
                image={coverImage === 'default' ? '/homeCover.jpg' : coverImage}
            />
        );
    }

    // Cover image-гүй — title + yellow underline (content хуудас шиг)
    if (!title) return null;

    return (
        <div className="max-w-4xl mx-auto px-6 pt-28 md:pt-36 lg:pt-40 pb-4">
            <h1 className="text-3xl md:text-4xl font-black text-brand-dark tracking-tight">
                {title.toUpperCase()}
            </h1>
            <div className="mt-3 h-1 w-16 bg-brand-yellow" />
            {subtitle && (
                <p className="mt-4 text-base lg:text-lg text-brand-gray max-w-3xl leading-relaxed">
                    {subtitle}
                </p>
            )}
        </div>
    );
}